import React from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';

import c from './preview.module.scss';

const Preview = ({ version, widgetId }) => {
  const editor = useEditor(
    {
      extensions: [
        StarterKit,
        Document,
        TaskList,
        TaskItem.configure({
          nested: false,
        }),
      ],
      editorProps: {
        attributes: {
          'aria-hidden': 'true',
          id: `widget-${widgetId}`,
          contentEditable: false,
        },
      },
      content: version,
    },
    [version, widgetId]
  );

  return (
    <div className={c.wrapper}>
      <EditorContent editor={editor} aria-labelledby={`widget-${widgetId}`} />
    </div>
  );
};

export default Preview;
